import React from "react";
import { CalendarView } from "./Meals";
export default function Movement() {
  return <CalendarView kind="movement" title="Movement" heading="Move like it matters" />;
}
